<script>
    import { doc } from "./util/stores.js"

    import Plot_board from "./module-boards/plot_board.svelte"
    import Setting_board from "./module-boards/setting_board.svelte"
    import Characters_board from "./module-boards/Characters_board.svelte"

    let work_page = "Characters"
    doc.subscribe((value) =>{
        work_page = value['current_page']
    })

    function AddNewTrack(page){
        if(page == 'Characters'){
            $doc['boards'][page] = [...$doc['boards'][page], {'modules': [{ 'type': 'char card'}, {'type': 'socionics'}] }]
        }
        //console.log($doc['modules']['Characters'])
        console.log('Added new '+page+' track')
    }

    function RemoveTrack(page, index){
        $doc['boards'][page].splice(index, 1)
        $doc['boards'][page] = $doc['boards'][page] //this line is needed to make svelte understand an assignment was made and everything should react. Docs dont explain how to deal with .splice properly
        //console.log(track_el_by_id[0])
        console.log('Removed '+page+' track index: ' + index)
    }

</script>

{#if work_page == "Plot"}
    <Plot_board removeTrack={RemoveTrack}></Plot_board>
{:else if work_page == "Setting"}
    <Setting_board addNewTrack={AddNewTrack} removeTrack={RemoveTrack}></Setting_board>
{:else if work_page == "Characters"}
    <Characters_board addNewTrack={AddNewTrack} removeTrack={RemoveTrack}></Characters_board>
{/if}

<style lang="scss">

</style>